import React, { useState } from 'react';
// import './Accordion.css'; // Migrating to Tailwind

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-border">
      <button
        className="w-full bg-none border-none text-left py-6 text-[1.1rem] font-medium text-primary cursor-pointer flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        {title}
        <span className={`w-3 h-3 border-r-2 border-b-2 border-primary rotate-45 transition-transform duration-300 ${isOpen ? '-rotate-[135deg]' : ''}`}></span>
      </button>
      <div className={`overflow-hidden transition-[max-height,padding] duration-500 ease-in-out px-4 ${isOpen ? 'max-h-[500px] pb-6' : 'max-h-0'}`}>
        <div className="flex flex-col gap-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;